import { useReducer } from 'react'
import { Action, State } from 'types'
import { mergeModels } from 'utils/mergeModels'
import { removeModels } from 'utils/removeModels'
import {
  ADD_ERROR,
  ADD_NOTICE,
  PERSIST_COMPANIES,
  PERSIST_DOCUMENTS,
  PERSIST_PRODUCTS,
  PERSIST_PROJECTS,
  PERSIST_OTHER_ROLES,
  PERSIST_TEMPLATE_DOCUMENTS,
  REMOVE_TEMPLATE_DOCUMENTS,
  PERSIST_USER,
  REMOVE_USER,
  REMOVE_ERRORS,
  ADD_PERMISSIONS,
  UPDATE_PERMISSIONS,
  ADD_DIRECTORIES
} from './actions'
import { initialState, initialUser } from './context'

export const useAppReducer = () => useReducer(reducer, initialState)

export const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    case PERSIST_USER:
      const { user } = action.payload
      return {
        ...state,
        errors: [],
        user,
      }

    case REMOVE_USER:
      const newState = {
        ...state,
        errors: [],
        user: initialUser,
      }

      return newState

    case PERSIST_DOCUMENTS:
      return {
        ...state,
        documents: mergeModels(state.documents, action.payload),
      }

    case PERSIST_TEMPLATE_DOCUMENTS:
      return {
        ...state,
        // templateDocuments: mergeModels(state.templateDocuments, action.payload),
        templateDocuments:  action.payload,
      }

    case REMOVE_TEMPLATE_DOCUMENTS:
      return {
        ...state,
        templateDocuments: removeModels(
          state.templateDocuments,
          action.payload,
        ),
      }

    case PERSIST_PROJECTS:
      return {
        ...state,
        projects: mergeModels(state.projects, action.payload),
      }

    case PERSIST_COMPANIES:
      return {
        ...state,
        companies: mergeModels(state.companies, action.payload),
      }
    case PERSIST_OTHER_ROLES:
      return {
          ...state,
          ...action.payload
      }
    case ADD_NOTICE:
      const newNotices = state.notices
      newNotices.push(action.payload)

      return {
        ...state,
        notices: newNotices,
      }

    case ADD_ERROR:
      const newErrors = state.errors
      newErrors.push(action.payload)

      return {
        ...state,
        errors: newErrors,
      }

    case REMOVE_ERRORS:
      return {
        ...state,
        errors: [],
      }

    case PERSIST_PRODUCTS:
      return {
        ...state,
        stripeProducts: action.payload,
      }

      case ADD_PERMISSIONS:
        return {
          ...state,
          permissionsList: action.payload
        }

        case UPDATE_PERMISSIONS:
        return {
          ...state,
          permissionsList: action.payload
        }

        case ADD_DIRECTORIES:
        return {
          ...state,
          directories: action.payload
        }

    default:
      return state
  }
}
